module.exports = __webpack_public_path__ + "static/media/musee_mecanique_logo.5c5d2e9a.jpg";